import React, { useState } from 'react';
import { isImageCached, preloadImage } from '../../services/mediaCache';

interface BlurImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
  priority?: boolean;
}

export const BlurImage: React.FC<BlurImageProps> = ({ src, alt, className = '', priority = false, ...props }) => {
  const [isLoading, setLoading] = useState(!isImageCached(src));

  const handleLoad = () => {
    preloadImage(src);
    setLoading(false);
  };

  return (
    <div className={`relative overflow-hidden bg-black/20 ${className}`}>
      <img
        alt={alt}
        src={src}
        loading={priority ? 'eager' : 'lazy'}
        decoding={priority ? 'sync' : 'async'}
        {...(priority ? { fetchPriority: 'high' } as any : {})}
        className={`
          duration-700 ease-in-out w-full h-full
          ${isLoading ? 'scale-110 blur-2xl grayscale' : 'scale-100 blur-0 grayscale-0'}
          ${className}
        `}
        onLoad={handleLoad}
        {...props}
      />
      {isLoading && (
        <div className="absolute inset-0 bg-white/5 animate-pulse" />
      )}
    </div>
  );
};
